"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginTemplates = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
class PluginTemplates {
    renderBackLink(buttonName, isTop, link) {
        if (link) {
            return ((0, jsx_runtime_1.jsx)("div", { className: `${isTop ? "back-link-top" : "back-link-bottom"}`, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: `btn btn-back-link`, onClick: () => { window.location.href = link; }, children: buttonName }) }));
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: `${isTop ? "back-link-top" : "back-link-bottom"}`, children: (0, jsx_runtime_1.jsx)("a", { onClick: this.goBack, children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: `btn btn-back-link`, children: buttonName }) }) }));
    }
    goBack(event) {
        event.target.href = window.history.back();
    }
}
exports.PluginTemplates = PluginTemplates;
//# sourceMappingURL=PluginTemplates.js.map